import { request, request2 } from "/src/utils/index.js";

export function CustomerDetail(params) {
  return request2.get("sdbs/customer/detail", { params });
}

export function RecordDetail(params) {
  return request2.get("tcm/medical/record/detail", { params });
}

export function GetReportDetail(params) {
  return request2.get("tcm/diagnosis/report/detail", { params });
}

export function UpdateCustomer(params) {
  return request2.put("sdbs/customer", params);
}

export function Save(params) {
  return request.put("tcm/medical/record", params);
}

export function SyndromeList(params) {
  return request2.get("tcm/syndrome/list", { params });
}

export function DiseaseList(params) {
  return request2.get("tcm/disease/list", { params });
}
export function GetSetting(params) {
  return request2.get("tcm/diagnosis/report/setting", { params });
}

export function GetOperation(params) {
  return request2.get("tcm/medical/record/operations", { params });
}

export function AddReportItem(params) {
  return request2.post("tcm/diagnosis/report/item", params);
}

export function Send(params) {
  return request2.post("tcm/medical/record/perform", params);
}

export function UpdateSyndromeList(params) {
  return request2.put("tcm/diagnosis/report/item/detail", params);
}

export function DeleteList(data) {
  return request2.delete("tcm/diagnosis/report/item", { data });
}

export function GetMaizhenyiList(params) {
  return request2.get("mz/maizhenyi/history/list", { params });
}

export function GetWuxing() {
  return request2.get("mz/maizhenyi/history/wuxing/list");
}

export function GetPulse() {
  return request2.get("mz/maizhenyi/history/pulse/list?isJi=0");
}

export function GetHealthAssessment(params) {
  return request2.get("tcm/healthAssessment/customer/list", { params });
}
export function InsertHealthAssessment(params) {
  return request2.post("tcm/medical/record/import/healthAssessment", params);
}

export function GetPrescriptionList(params) {
  return request2.get("/tcm/medical/record/prescription/list", { params });
}
// 导出一个函数AddPrescriptionInfo，用于添加处方信息
export function AddPrescriptionInfo(params) {
  // 发送post请求，请求地址为tcm/medical/record/prescription，参数为params
  return request2.post("tcm/medical/record/prescription", params);
}

export function GetMedicineOption(params) {
  return request2.get("/tcm/medical/record/prescription/medicine/list", {
    params,
  });
}

export function AddMedical(params) {
  // 发送post请求，请求地址为tcm/medical/record/prescription，参数为params
  return request2.post("tcm/medical/record/prescription/item", params);
}

export function UpdateMedical(params) {
  return request2.put("tcm/medical/record/prescription/item", params);
}
export function DeleteMedical(data) {
  return request2.delete("tcm/medical/record/prescription/item", { data });
}

export function UpdatePrescription(params) {
  return request2.put("tcm/medical/record/prescription", params);
}

export function GetTakingMethods(params) {
  return request2.get("tcm/medical/record/prescription/takingMethods", {
    params,
  });
}

export function AddPrescription(params) {
  return request2.post("tcm/medical/record/prescription", params);
}

export function DeletePrescription(data) {
  return request2.delete("tcm/medical/record/prescription", { data });
}

export function AiGenerate(params) {
  return request2.post("tcm/medical/record/prescription/aiGenerate", params);
}

export function RecordList(params) {
  return request2.get("tcm/medical/record/list", {
    params,
  });
}

export function RecordCopy(params) {
  return request2.post("tcm/medical/record/copy", params);
}

export function GetTemplate(params) {
  return request2.get("tcm/medical/record/template", {
    params,
  });
}